import { FC, PropsWithChildren } from 'react';
import { StyledNotice } from './Notice.styles';
import { AlertTriangle, InfoCircle } from '../../icons';

export const enum NoticeStyle {
  Success = 'success',
  Info = 'info',
  Warning = 'warning',
  Error = 'error',
}

export interface NoticeProps extends PropsWithChildren {
  noticeStyle?: NoticeStyle;
  title?: string;
}

/**
 * A notice-style card for displaying important messages.
 */
export const Notice: FC<NoticeProps> = ({
  noticeStyle = NoticeStyle.Info,
  title,
  children,
}) => {
  // TODO: make dismissable?
  return (
    <StyledNotice $noticeStyle={noticeStyle}>
      {noticeStyle === NoticeStyle.Error && <AlertTriangle />}
      {noticeStyle === NoticeStyle.Warning && <AlertTriangle />}
      {noticeStyle === NoticeStyle.Info && <InfoCircle />}
      {title && <h3>{title}</h3>}
      <p>{children}</p>
    </StyledNotice>
  );
};

export default Notice;
